import { render, staticRenderFns } from "./SniperIcon.vue?vue&type=template&id=1962e170&scoped=true"
import script from "./SniperIcon.vue?vue&type=script&lang=js"
export * from "./SniperIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1962e170",
  null
  
)

export default component.exports